import PropTypes from 'prop-types';

import { ItemType } from 'Type/ProductList.type';

export const PopupCartType = PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        product: ItemType,
        quantity: PropTypes.number
    })),
    total_quantity: PropTypes.number,
    prices: PropTypes.shape({
        subtotal_including_tax: PropTypes.shape({
            value: PropTypes.number,
            currency: PropTypes.string
        })
    }),
    freeshipping_min_amount: PropTypes.number,
    freeshipping_remaining_amount: PropTypes.number,
    cross_product_skus: PropTypes.arrayOf(PropTypes.string)
});

export const CouponType = PropTypes.shape({
    code: PropTypes.string,
    description: PropTypes.string
});

export const GiftProductType = PropTypes.shape({
    id: PropTypes.number,
    sku: PropTypes.string,
    name: PropTypes.string,
    thumbnail: PropTypes.shape({
        url: PropTypes.string
    }),
    is_in_cart_free_product: PropTypes.bool,
    cart_item_id: PropTypes.number,
    qty_as_free_product: PropTypes.number
});

export const GiftProductChoiceType = PropTypes.shape({
    rule_id: PropTypes.number,
    title: PropTypes.string,
    max_products_allowed: PropTypes.number,
    current_products_in_cart: PropTypes.number,
    products: PropTypes.arrayOf(GiftProductType)
});
